module.exports = __webpack_public_path__ + "images/index/img07.4c7683d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/artfriends/img07.jpg
// module id = SXu4
// module chunks = 21